import { render, staticRenderFns } from "./smallSixRecommend.vue?vue&type=template&id=1c6fd0a4&scoped=true&"
import script from "./smallSixRecommend.vue?vue&type=script&lang=js&"
export * from "./smallSixRecommend.vue?vue&type=script&lang=js&"
import style0 from "./smallSixRecommend.vue?vue&type=style&index=0&id=1c6fd0a4&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c6fd0a4",
  null
  
)

export default component.exports